/**
 * Deep-link plumbing for the exceedance action drawer: the open drawer's identity
 * mirrors into `?drawer=<facilityId>~<source>~<periodStart>` so a drawer view is
 * shareable/bookmarkable, back/forward walk drawer history, and the drawer's own
 * "separate discrepancy" cross-links can point at sibling rows. Kept separate from
 * the `omnisearch` param — omnisearch's URL updates preserve foreign params, so the
 * two coexist.
 */

export const DRAWER_PARAM = "drawer";

/** `~` is URL-unreserved and can't occur in a uuid, source name, or ISO date. */
const DRAWER_PARAM_SEPARATOR = "~";

/** The (facilityId, source, periodStart) natural key of one exceedance row. */
export type DrawerDeepLinkKey = {
  facilityId: string;
  source: string;
  periodStart: string;
};

export function toDrawerParam(key: DrawerDeepLinkKey): string {
  return [key.facilityId, key.source, key.periodStart].join(DRAWER_PARAM_SEPARATOR);
}

export function parseDrawerParam(value: string | null): DrawerDeepLinkKey | null {
  if (!value) return null;
  const [facilityId, source, periodStart] = value.split(DRAWER_PARAM_SEPARATOR);
  if (!facilityId || !source || !periodStart) return null;
  return { facilityId, source, periodStart };
}
